var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"pap-form__form-header card-header bg-primary text-white"},[_c('div',{staticClass:"icon-wrapper"},[_c('i',{class:_vm.iconclass})]),_c('div',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }